/**
 * 用章申请审核列表信息
 */
import React from 'react';

import { Row, Col, Icon, Tooltip, DatePicker, Select } from 'antd';

import PageLayout from '../../ui/PageLayout';

import ChapterApplyAudit from './ChapterApplyAudit';
import ChapterApplyDetail from './ChapterApplyDetail';

import { global_data } from '../../ui/auth'
import http from '../../../axios/http';

const auditStatus = {
    // "NOT_START": "未开始", "START": "业务发起审核",
    "SUBMIT": "提交申请", "DEPARTMENT_MANAGER": "部门经理审核", "GENERAL_MANAGER": "总经理审核",
    "ADMINISTRATIVE": "行政审核", "FAIL": "未通过", "SUCCESS": "已通过"
};

class ChapterApplyIndex extends React.Component {

    columns = [{
        title: '申请名称',
        dataIndex: 'flowName',
        width: '10%',
    }, {
        title: "描述信息",
        dataIndex: 'des',
        width: '25%',
    }, {
        title: '流程状态',
        dataIndex: 'status',
        width: '10%',
        format: auditStatus
    }, {
        title: '创建时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '创建人',
        dataIndex: 'creator',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {
                    global_data.authCode.includes("CHAPTER_APPLY_EXAMINE")&&
                    ((record.status === "DEPARTMENT_MANAGER" && this.state.auditAuth["CHAPTER_APPLY_DEPARTMENT_MANAGER"])
                        ||
                        (record.status === "GENERAL_MANAGER" && this.state.auditAuth["CHAPTER_APPLY_GENERAL_MANAGER"])
                        ||
                        (record.status === "ADMINISTRATIVE" && this.state.auditAuth["CHAPTER_APPLY_ADMINISTRATIVE"]))
                        ?
                        <Tooltip title="审核">
                            <Icon type="audit" className="table-operate-icon" onClick={this.audit.bind(this, record)} />
                        </Tooltip>
                        : ""
                }
                <Tooltip title="详细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        queryData: {},
        auditAuth: {},
        auditList: []
    };

    componentDidMount() {
        let authCodes = ["CHAPTER_APPLY_DEPARTMENT_MANAGER", "CHAPTER_APPLY_GENERAL_MANAGER", "CHAPTER_APPLY_ADMINISTRATIVE"];
        let auditAuth = {};
        for (let i = 0; i < global_data.authCode.length; i++) {
            for (let j = 0; j < authCodes.length; j++) {
                if (global_data.authCode[i] === authCodes[j]) {
                    auditAuth[authCodes[j]] = true;
                }
            }
        }
        this.setState({ auditAuth: auditAuth });
    }

    audit = (info, e) => {
        info.opinion = true;
        this.setState({ visible: true, editData: info });
    }

    detail = (info, e) => {
        http.post({
            url: '/chapterApply/findAuditInfo',
            data: { applyId: info.id },
            success: (res) => {
                this.setState({ detailVisible: true, editData: info, auditList: res == null ? [] : res });
            }
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }

    selectChange = (value) => {
        let queryData = this.state.queryData;
        queryData.status = value;
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }

    render() {
        let doms = [];
        for (var key in auditStatus) {
            doms.push(<Select.Option value={key}>{auditStatus[key]}</Select.Option>);
        };
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <Select defaultValue="" style={{ width: 180, marginLeft: '10px', marginRight: '10px' }} onChange={this.selectChange}>
                                    <Select.Option value="">全部</Select.Option>
                                    {doms}
                                </Select>
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/chapterApply/pageChapterApply" columns={this.columns}
                    loadData={(func) => { this.loadData = func }}
                />
                <ChapterApplyAudit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false }) }}
                    editData={this.state.editData}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                    auditAuth={this.state.auditAuth}
                />
                <ChapterApplyDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false }) }}
                    editData={this.state.editData}
                    auditList={this.state.auditList}
                    auditStatus={auditStatus}
                />
            </div>
        )
    }
}

export default ChapterApplyIndex;